import * as S from "./StoreBlock.styles";
import React from "react";
import { Button } from "@ubnt/ui-components";
import { useSiteSettings } from "context/SiteSettingsContext";
import { useTranslation } from "hooks/useTranslation";

export const StoreBlock = () => {
  const { t } = useTranslation();
  const { routes } = useSiteSettings();

  return (
    <S.ContentWrapper>
      <S.Text>{t("gettingStartedWithUniFi.topology.ready.label")}</S.Text>

      <a
        href={routes.store.category("all-cloud-gateways")}
        target="_blank"
        rel="noopener noreferrer"
      >
        <Button variant="primary">{t("commons.goToStore")}</Button>
      </a>
    </S.ContentWrapper>
  );
};
